import { api } from "@/http/api-client"

import type {
  TChangelogEntryWithTags,
  TListEntriesResponse,
} from "./types"

export type TListEntriesParams = {
  serviceId: string
  organizationSlug: string
  page?: number
  tagId?: string
}

export function listEntries(params: TListEntriesParams) {
  const searchParams = new URLSearchParams()
  searchParams.set("organizationSlug", params.organizationSlug)
  if (params.page) searchParams.set("page", String(params.page))
  if (params.tagId) searchParams.set("tagId", params.tagId)

  return api.get<TListEntriesResponse>(
    `/changelog/services/${params.serviceId}/entries?${searchParams.toString()}`,
  )
}

export type TGetEntryParams = {
  serviceId: string
  entryId: string
  organizationSlug: string
}

export function getEntry(params: TGetEntryParams) {
  const searchParams = new URLSearchParams()
  searchParams.set("organizationSlug", params.organizationSlug)

  return api.get<TChangelogEntryWithTags>(
    `/changelog/services/${params.serviceId}/entries/${params.entryId}?${searchParams.toString()}`,
  )
}

export type TCreateEntryParams = {
  serviceId: string
  title: string
  content?: string
  publishedAt?: string
  isPublished?: boolean
  tagIds?: string[]
  tempFileIds?: string[]
  organizationSlug: string
}

export function createEntry(params: TCreateEntryParams) {
  const { serviceId, ...body } = params
  return api.post<TChangelogEntryWithTags>(
    `/changelog/services/${serviceId}/entries`,
    { json: body },
  )
}

export type TUpdateEntryParams = {
  serviceId: string
  entryId: string
  title?: string
  content?: string
  publishedAt?: string | null
  isPublished?: boolean
  tagIds?: string[]
  tempFileIds?: string[]
  organizationSlug: string
}

export function updateEntry(params: TUpdateEntryParams) {
  const { serviceId, entryId, ...body } = params
  return api.patch<TChangelogEntryWithTags>(
    `/changelog/services/${serviceId}/entries/${entryId}`,
    { json: body },
  )
}

export type TDeleteEntryParams = {
  serviceId: string
  entryId: string
  organizationSlug: string
}

export function deleteEntry(params: TDeleteEntryParams) {
  return api.delete(
    `/changelog/services/${params.serviceId}/entries/${params.entryId}`,
    { json: { organizationSlug: params.organizationSlug } },
  )
}

export type TDeleteMediaParams = {
  serviceId: string
  mediaId: string
  organizationSlug: string
}

export function deleteMedia(params: TDeleteMediaParams) {
  return api.delete(
    `/changelog/services/${params.serviceId}/media/${params.mediaId}`,
    { json: { organizationSlug: params.organizationSlug } },
  )
}

export type TImportMarkdownParams = {
  serviceId: string
  markdown: string
  title: string
  publishedAt?: string
  isPublished?: boolean
  tagIds?: string[]
  organizationSlug: string
}

export function importMarkdown(params: TImportMarkdownParams) {
  const { serviceId, ...body } = params
  return api.post<TChangelogEntryWithTags>(
    `/changelog/services/${serviceId}/entries/import-markdown`,
    { json: body },
  )
}
